import ApplicationSerializer from "./application";

export default class InviteSerializer extends ApplicationSerializer {
  usesProxy = true;

  primaryKey = "invitecode";
}
